<div class="welcome-onboarding">
  <!-- Header gradient -->
  <div class="header-gradient">
    <div class="icon-circle">
      <mat-icon class="!w-10 !h-10 text-white" [svgIcon]="slides[currentSlide].icon"></mat-icon>
    </div>
    <div class="slide-counter">{{ currentSlide + 1 }} / {{ slides.length }}</div>
  </div>

  <!-- Content -->
  <div class="content">
    <h2>{{ slides[currentSlide].title }}</h2>
    <p class="description">{{ slides[currentSlide].description }}</p>

    <ul class="bullets" *ngIf="slides[currentSlide].bullets?.length">
      <li *ngFor="let bullet of slides[currentSlide].bullets">
        <mat-icon class="bullet-icon !w-5 !h-5" [svgIcon]="'tabler_outline:check'"></mat-icon>
        <span>{{ bullet }}</span>
      </li>
    </ul>
  </div>

  <!-- Dots indicator -->
  <div class="dots">
    <span
      *ngFor="let slide of slides; let i = index"
      class="dot"
      [class.active]="i === currentSlide"
      (click)="currentSlide = i"
    ></span>
  </div>

  <!-- Actions -->
  <div class="actions">
    <!-- Standardowy slajd (nie-ostatni) -->
    <ng-container *ngIf="!isLastSlide">
      <button mat-button color="primary" (click)="skip()" class="skip-btn">
        Pomiń
      </button>
      <div class="nav-buttons">
        <button mat-stroked-button color="primary" (click)="prev()" *ngIf="!isFirstSlide">
          <mat-icon class="!w-4 !h-4" [svgIcon]="'tabler_outline:arrow-left'"></mat-icon>
          Wstecz
        </button>
        <button mat-flat-button color="primary" (click)="next()">
          Dalej
          <mat-icon class="!w-4 !h-4" [svgIcon]="'tabler_outline:arrow-right'"></mat-icon>
        </button>
      </div>
    </ng-container>

    <!-- Ostatni slajd (KSeF) -->
    <ng-container *ngIf="isLastSlide">
      <button mat-button color="primary" (click)="finish()" class="skip-btn">
        Zrobię to później
      </button>
      <div class="nav-buttons">
        <button mat-stroked-button color="primary" (click)="prev()">
          <mat-icon class="!w-4 !h-4" [svgIcon]="'tabler_outline:arrow-left'"></mat-icon>
          Wstecz
        </button>
        <button mat-flat-button color="primary" (click)="connectKsef()">
          <mat-icon class="!w-4 !h-4" [svgIcon]="'tabler_outline:plug-connected'"></mat-icon>
          Połącz z KSeF
        </button>
      </div>
    </ng-container>
  </div>
</div>
